const generateQueryKeyFromObject = (object: object): string[] =>
  Object.entries(object)
    .map(([key, value]) => `${key}-${JSON.stringify(value)}`)
    .sort();

export default generateQueryKeyFromObject;
